import React from "react";
import Logo from "../../img/loginLogo.png";

import {
  Button,
  Grid,
  Typography,
  IconButton,
  Fade,
  CircularProgress,
} from "@material-ui/core";
import TextField from "../../components/TextField";
import Countdown from "react-countdown";
import {
  confirm_register,
  SubmitRegister,
} from "../../redux/Login/LoginActions";

import { connect } from "react-redux";
import { Form, Formik } from "formik";
import {
  initialValue,
  validationSchema,
} from "../../validation/RegisterGetCodeValidation";
import Captcha from "../../components/Captcha";

import { Refresh } from "@material-ui/icons";
import { authUnauthorizedMessage } from "../../redux/Login/LoginActionCreators";
import Store from "../../redux/Store";

const RegisterGetCode = ({
  Register_Mobile_Email,
  resetCaptcha,
  authError,
  loading,
}) => {
  const timer = 120 * 1000;

  React.useEffect(() => {
    Store.dispatch(authUnauthorizedMessage(""));
  }, []);

  let time = Date.now() + timer;
  const handleReset = () => {
    SubmitRegister({ username: Register_Mobile_Email });
  };

  const Renderer = ({ minutes, seconds, completed }) => {
    if (completed) {
      return <Completionist handler={handleReset} />;
    } else {
      return (
        <Typography variant="body1" color="secondary">
          {minutes}:{seconds}
        </Typography>
      );
    }
  };
  let [open, setOpen] = React.useState(false);

  React.useLayoutEffect(() => {
    setOpen(true);

    return () => {
      setOpen(false);
    };
  }, []);
  return (
    <Formik
      initialValues={initialValue}
      validationSchema={validationSchema}
      validateOnMount
      onSubmit={(values, props) => {
        confirm_register(values);
      }}
    >
      {(formik) => {
        return (
          <Form>
            <Fade in={open} timeout={500}>
              <Grid
                container
                justifyContent="center"
                alignItems="center"
                style={{ height: "100vh", backgroundColor: "#F2F2F6" }}
              >
                <Grid
                  container
                  item
                  justifyContent="center"
                  spacing={4}
                  xs={10}
                  sm={6}
                  md={5}
                  lg={4}
                  xl={3}
                  style={{
                    backgroundColor: "white",
                    borderRadius: "20px",
                    boxShadow: "0 3px 6px rgba(0,0,0,0.1)",
                    paddingTop: "51px",
                    paddingBottom: "51px",
                  }}
                >
                  <Grid
                    item
                    md={10}
                    xs={12}
                    container
                    justifyContent="center"
                    spacing={4}
                  >
                    <Grid item xs={12} container justifyContent="center">
                      <img src={Logo} alt="logo" />
                    </Grid>
                    <Grid item xs={12} container justifyContent="center">
                      <Typography color="textSecondary" variant="subtitle2">
                        رمز درخواستی به{" "}
                        {isNaN(Register_Mobile_Email)
                          ? " آدرس ایمیل "
                          : "شماره موبایل "}
                        زیر ارسال شد
                      </Typography>
                    </Grid>
                    <Grid item xs={12} container justifyContent="center">
                      <Typography variant="subtitle2" color="secondary">
                        {Register_Mobile_Email}
                      </Typography>
                    </Grid>
                    <Grid item xs={12} container justifyContent="center">
                      <Typography variant="subtitle2" color="secondary">
                        {authError}
                      </Typography>
                    </Grid>
                    <Grid item xs={12}>
                      <TextField name="temp_token" label="رمز ورود" />
                    </Grid>

                    <Grid item container justifyContent="center">
                      <Countdown
                        date={time}
                        renderer={Renderer}
                        key={resetCaptcha}
                      />
                    </Grid>

                    <Grid item xs={12}>
                      <Button
                        disabled={!formik.isValid || loading}
                        fullWidth
                        variant="contained"
                        color="primary"
                        type="submit"
                      >
                        {" "}
                        {!loading ? (
                          "  تایید"
                        ) : (
                          <CircularProgress
                            style={{
                              color: "white",
                              height: 24,
                              width: 24,
                            }}
                          />
                        )}
                      </Button>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Fade>
          </Form>
        );
      }}
    </Formik>
  );
};

const mapStateToProps = (props) => {
  const { loginReducer } = props;
  const { Register_Mobile_Email, resetCaptcha, authError, loading } =
    loginReducer;
  return { Register_Mobile_Email, resetCaptcha, authError, loading };
};

export default connect(mapStateToProps)(RegisterGetCode);
const Completionist = ({ handler }) => {
  return (
    <>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Typography
          variant="body1"
          color="textSecondary"
          style={{ paddingBottom: "20px" }}
        >
          برای ادامه دوباره درخواست رمز کنید
        </Typography>

        <IconButton
          color="primary"
          disabled={true}
          onClick={(e) => {
            e.stopPropagation();
            // handler();
          }}
        >
          <Refresh color="primary" fontSize="large" />
        </IconButton>
        <Captcha handler={handler} />
      </div>
    </>
  );
};
